import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '@common/hooks/translation';
import KeyboardInput from '@common/components/InputKeyboard';
import { PreferencesContext } from '@common/contexts/preferences';

export const Search = ({ onSearchChange, providerExpanded }) => {
  const t = useTranslation();
  const [{ lang }] = useContext(PreferencesContext);

  return (
    <div className={`search-container-column casino ${providerExpanded ? 'list-expanded' : ''} `}>
      <div className="single-form-item">
        <KeyboardInput
          enabled
          onChange={onSearchChange}
          lang={lang}
          placeholder={t('Search')}
          isDraggable={false}
          isFirstLetterUppercase={false}
          hasResetButton
        />
      </div>
    </div>
  );
};

Search.propTypes = {
  onSearchChange: PropTypes.func,
  providerExpanded: PropTypes.bool,
};
